export const kanaele = [
    {mode: 'D', number: '9001', label: 'ZS 1'},
    {mode: 'D', number: '9002', label: 'ZS 2'},
    {mode: 'D', number: '9003', label: 'ZS 3'},
    {mode: 'D', number: '9004', label: 'ZS 4'},
    {mode: 'D', number: '9005', label: 'ZS 5'},
    {mode: 'G', number: '9101', label: 'KAPO ZH EL'},
    {mode: 'G', number: '9102', label: 'ZS KEE 1'},
    {mode: 'G', number: '9103', label: 'ZS KEE 2'},
    {mode: 'G', number: '9104', label: 'FW Kt. ZH'},
    {mode: 'D', number: '9086', label: 'ZSO KEE DIR 1'},
    {mode: 'D', number: '9065', label: 'ZSO KEE DIR 2'},
    {mode: 'D', number: '9054', label: 'ZSO KEE DIR 3'},
    {mode: 'D', number: '9025', label: 'ZSO AND DIR'},
    {mode: 'D', number: '9054', label: 'ZS Kt. ZH'},
    {mode: 'G', number: '9152', label: 'KAPO BL Velo WM'},
    {mode: 'G', number: '9145', label: 'FW Andelfingen'},
    {mode: 'G', number: '9156', label: 'ZS BL 2'},
    {mode: 'G', number: '9119', label: 'FW Kt. AI'}
]